
const StringToBooleanOrderTransformer = require('./transformers/order/boolean').StringToBooleanOrderTransformer
const ArtworkRequiredLineItemTransformer = require('./transformers/lineItem/boolean').ArtworkRequiredLineItemTransformer
const StringToLongLineItemTransformer = require('./transformers/lineItem/number').StringToLongLineItemTransformer
const ArrayOfArrayOfStringToArrayOfStringJsonTransformer = require('./transformers/lineItem/json').ArrayOfArrayOfStringToArrayOfStringJsonTransformer
const ArrayOfStringToArrayOfStringJsonTransformer = require('./transformers/lineItem/json').ArrayOfStringToArrayOfStringJsonTransformer
const ArrayOfStringToStringJsonTransformer = require('./transformers/lineItem/json').ArrayOfStringToStringJsonTransformer
const ArtworkUploadUrlMergeAndTransform = require('./transformers/lineItem/json').ArtworkUploadUrlMergeAndTransform
const StringToDateTimeTransformer = require('./transformers/lineItem/dateTime').StringToDateTimeTransformer


module.exports = {
  getFakeOrderTransformer: () => {
    return {
      v1Field: 'fakeOrder',
      v2Field: 'fakeOrderV2',
      transformer: StringToBooleanOrderTransformer()
    }
  },
  getArtworkRequiredTransformer: () => {
    return {
      v1Field: 'artworkRequired',
      v2Field: 'artworkRequiredV2',
      transformer: ArtworkRequiredLineItemTransformer()
    }
  },
  getPromisedArrivalDateTransformer: () => {
    return {
      v1Field: 'promisedArrivalDate',
      v2Field: 'promisedArrivalDateV2',
      transformer: StringToDateTimeTransformer()
    }
  },
  getRevisedPromisedArrivalDateTransformer: () => {
    return {
      v1Field: 'revisedPromisedArrivalDate',
      v2Field: 'revisedPromisedArrivalDateV2',
      transformer: StringToDateTimeTransformer()
    }
  },
  getShippingAddressPerLineItemTransformer: () => {
    return {
      v1Field: 'shippingAddressPerLineItem',
      v2Field: 'shippingAddressPerLineItemV2',
      transformer: ArrayOfArrayOfStringToArrayOfStringJsonTransformer()
    }
  },
  getUserUploadsUrlTransformer: () => {
    return {
      v1Field: 'userUploadsUrl',
      v2Field: 'userUploadsUrlV2',
      transformer: ArrayOfStringToArrayOfStringJsonTransformer(["artworkUploadId", "artworkName", "artworkUrl", "uploadTimestamp"])
    }
  },
  getUserSelectionTransformer: () => {
    return {
      v1Field: 'userSelection',
      v2Field: 'userSelectionV2',
      transformer: ArrayOfStringToStringJsonTransformer()
    }
  },
  getVariableAttributesTransformer: () => {
    return {
      v1Field: 'variableAttributes',
      v2Field: 'variableAttributesV2',
      transformer: ArrayOfStringToStringJsonTransformer()
    }
  },
  getFinalSelectionTransformer: () => {
    return {
      v1Field: 'finalSelection',
      v2Field: 'finalSelectionV2',
      transformer: ArrayOfStringToStringJsonTransformer()
    }
  },
  getMcpDocumentsSourceTransformer: () => {
    return {
      v1Field: 'mcpDocumentsSource',
      v2Field: 'mcpDocumentsSourceV2',
      transformer: ArrayOfStringToStringJsonTransformer()
    }
  },
  getArtworkUploadURLTransformer: () => {
    return {
      v1Field: 'artworkUploadURL',
      v1SecondaryField: 'additionalReviewedArtwork',
      v2Field: 'artworkUploadUrlV2',
      transformer: ArtworkUploadUrlMergeAndTransform()
    }
  },
  getBufferArtworkServiceHoursTransformer: () => {
    return {
      v1Field: 'bufferArtworkServiceHours',
      v2Field: 'bufferArtworkServiceHoursV2',
      transformer: StringToLongLineItemTransformer()
    }
  },
  getBufferProductionHoursTransformer: () => {
    return {
      v1Field: 'bufferProductionHours',
      v2Field: 'bufferProductionHoursV2',
      transformer: StringToLongLineItemTransformer()
    }
  },
  getMcpProductionHoursTransformer: () => {
    return {
      v1Field: 'mcpProductionHours',
      v2Field: 'mcpProductionHoursV2',
      transformer: StringToLongLineItemTransformer()
    }
  }
}


// WEBPACK FOOTER //
// ./node_modules/@abc/transformers/src/index.js